import axios from 'axios';

export const isLocalhost = () =>
  typeof window !== 'undefined' && window.location.hostname.endsWith('localhost');
// TODO http://exactbuyer-git-master-exactbuyer.vercel.app/
export const isStaging = () =>
  typeof window !== 'undefined' &&
  (window?.location?.hostname?.endsWith('exactbuyer.vercel.app') ||
    window?.location?.hostname?.endsWith('staging.exactbuyer.com'));
export const isProd = () => process.env.NODE_ENV === 'production' && !isStaging() && !isLocalhost();

const getConfig = (cancelToken = null) => {
  let config = {
    baseURL: isProd()
      ? 'https://api.exactbuyer.com'
      : isStaging()
      ? `https://0${process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF.substring(
          0,
          9,
        )}0-dot-exactbuyer-api-staging.wl.r.appspot.com`
      : 'http://localhost:8085',

    withCredentials: true,
  };
  if (cancelToken) {
    config = { ...config, cancelToken };
  }
  return config;
};

export const openURL = (url) => {
  const config = getConfig();
  window.open(`${config.baseURL}${url}`);
};

const ajaxPromise = async (url, type, data = {}, cancelToken = null) => {
  const config = getConfig(cancelToken);
  const processedUrl = url;
  if (type === 'POST') {
    return axios.post(processedUrl, data, config);
  }
  if (type === 'GET') {
    return axios.get(url, Object.keys(data).length ? { ...config, params: { ...data } } : config);
  }
};
export default ajaxPromise;
export { getConfig };
